import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import apiClient from "../../../services/apiClient";

// 신고한 오류를 고쳤을 때 첫 화면에 한 번 띄우는 알림.
//
// **신고한 학원에게만 뜬다.** 남의 신고까지 알리면 상관없는 알림이 잦아진다.
// 서버가 '아직 못 본 처리완료'(`is_result_unseen`)를 표시해 주므로 기기를 바꿔도
// 한 번만 뜬다. 닫거나 보러 가면 본 것으로 친다.
//
// 다른 팝업과 겹치지 않게 `onResolved` 로 차례를 넘긴다(월간 결산과 같은 방식).
const FixNoticePopup = ({ onResolved }) => {
  const navigate = useNavigate();
  const [reportList, setReportList] = useState([]);

  useEffect(() => {
    let isDone = false;
    const finish = () => {
      if (isDone) return;
      isDone = true;
      if (onResolved) onResolved();
    };

    apiClient
      .get("/api/v1/support/reports", { withAuth: true })
      .then((response) => {
        const unseenList = (response.data.rows || []).filter(
          (row) => row.is_result_unseen
        );
        if (unseenList.length === 0) return finish();
        setReportList(unseenList);
      })
      .catch(finish);
  }, [onResolved]);

  if (reportList.length === 0) return null;

  const close = () => {
    // 본 것으로 표시한다. 실패해도 화면은 닫는다. 다음에 한 번 더 뜰 뿐이다.
    apiClient
      .post("/api/v1/support/reports/seen", {}, { withAuth: true })
      .catch(() => {});
    setReportList([]);
    if (onResolved) onResolved();
  };

  const openBoard = () => {
    const firstReport = reportList[0];
    close();
    navigate(`/academy/support?report=${firstReport.id}`);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(14,20,27,.55)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "18px",
      }}
    >
      <div
        style={{
          background: "#fff",
          maxWidth: "380px",
          width: "100%",
          overflow: "hidden",
          boxShadow: "0 30px 70px -30px rgba(10,30,35,.6)",
        }}
      >
        <div
          style={{
            background: "#0E141B",
            color: "#fff",
            padding: "20px 22px 18px",
            position: "relative",
          }}
        >
          <button
            type="button"
            aria-label="닫기"
            onClick={close}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "none",
              border: "none",
              color: "#6d7d7b",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              padding: "4px 6px",
            }}
          >
            ×
          </button>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: ".1em",
              color: "#00D9C0",
              marginBottom: "8px",
            }}
          >
            오류 신고
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, lineHeight: 1.4 }}>
            신고하신 오류를
            <br />
            수정했습니다
          </div>
        </div>
        <div style={{ padding: "18px 22px 22px" }}>
          <div style={{ display: "grid", gap: "8px" }}>
            {reportList.slice(0, 3).map((report) => (
              <div
                key={report.id}
                style={{
                  background: "#F2F8F7",
                  borderLeft: "3px solid #00A396",
                  padding: "10px 12px",
                  fontSize: "13px",
                  lineHeight: 1.6,
                  color: "#3A434E",
                }}
              >
                {report.text.length > 60
                  ? `${report.text.slice(0, 60)}...`
                  : report.text}
              </div>
            ))}
          </div>
          {reportList.length > 3 && (
            <div style={{ marginTop: "8px", fontSize: "12px", color: "#8a949c" }}>
              그 밖에 {reportList.length - 3}건을 더 처리했습니다.
            </div>
          )}
          <button
            type="button"
            onClick={openBoard}
            style={{
              display: "block",
              width: "100%",
              border: "none",
              cursor: "pointer",
              marginTop: "16px",
              background: "#00A396",
              color: "#fff",
              fontWeight: 800,
              fontSize: "15px",
              padding: "13px 0",
              textAlign: "center",
            }}
          >
            처리 내역 보기
          </button>
          <div
            style={{
              marginTop: "10px",
              fontSize: "12px",
              color: "#8a949c",
              textAlign: "center",
            }}
          >
            학원 관리 &gt; 오류 신고에서 언제든 다시 볼 수 있습니다
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixNoticePopup;
